import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { getSectionRootFromVariantPickerBlock, getSectionScopedRoot } from '@theme/utilities';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    const d = event.detail.data;
    if (d.newProduct) {
      this.dataset.productId = String(d.newProduct.id);
    } else if (
      d.productId != null &&
      String(d.productId) !== '' &&
      String(d.productId) !== String(this.dataset.productId ?? '')
    ) {
      return;
    }

    const doc = d.html;
    if (!doc) return;

    const section = this.closest('.shopify-section');
    const scope =
      getSectionRootFromVariantPickerBlock(doc, d.variantPickerBlockId) ||
      getSectionScopedRoot(doc, section) ||
      doc;

    const pid = String(this.dataset.productId ?? '');
    const newPrice =
      (pid &&
        scope.querySelector(`product-price[data-product-id="${pid}"] [ref="priceContainer"]`)) ||
      scope.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
